"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useFilterBuilder;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

// const filterMap = {
//   searchText: 'searchText',
//   g1: 'g1',
//   g2: 'g2',
//   g3: 'g3',
// };
// const filterPrototype = [
//   { field: 'searchText', operator: 'contains', value: undefined, toQuery: (v) => textContainsToQuery('searchText', v) },
//   { field: 'g1', operator: 'contains', value: undefined, toQuery: (v) => inToQuery('taxonomies', v) },
//   { field: 'g2', operator: 'contains', value: undefined, toQuery: (v) => inToQuery('taxonomies', v) },
//   { field: 'g3', operator: 'contains', value: undefined, toQuery: (v) => inToQuery('taxonomies', v) },
// ];
// returns (parentFilter, filter) => filter
function useFilterBuilder(filterMap, filterPrototype) {
  return _react.default.useCallback(function (parentFilter, filter) {
    return Object.entries(filter).reduce(function (resultFilter, _ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          sfn = _ref2[0],
          sfv = _ref2[1];

      var ffn = filterMap[sfn];
      var index = resultFilter.findIndex(function (i) {
        return i.field === ffn;
      });

      if (index === -1) {
        return !sfv ? resultFilter : [].concat((0, _toConsumableArray2.default)(resultFilter), [(0, _extends2.default)({}, filterPrototype.find(function (x) {
          return x.field === ffn;
        }), {
          value: sfv
        })]);
      }

      resultFilter[index] = !sfv || Array.isArray(sfv) && sfv.length === 0 ? null : (0, _extends2.default)({}, resultFilter[index], {
        value: sfv
      });
      return resultFilter.filter(Boolean);
    }, (0, _toConsumableArray2.default)(parentFilter));
  }, [filterMap, filterPrototype]);
}